import { useMemo } from "react";
import { useFetchPaginatedData } from "@hooks/api/useFetchPaginatedData";
import { GetAllTemplatesEmails } from "@services/TemplateEmail/Index";

// Mapeamento para relacionar tipos simplificados com os valores no emailTypes
const tipoMap = {
  COMUNICADO: "ENVIO_COMUNICADO",
  SOLICITACAO: "ENVIO_SOLICITACAO",
  RELATORIO: "ENVIO_RELATORIO",
  PLANO_ACAO: "ENVIO_PLANO_ACAO",
  ENCERRAMENTO: "ENCERRAMENTO_SOLICITACAO",
};

export function useFetchDataTemplatesEmails() {
  const { data, loading, fetchAllData } = useFetchPaginatedData(GetAllTemplatesEmails);

  const fixedOption = useMemo(() => [
    { value: 0, label: 'Não Enviar' }
  ], []);

  const comunicadoOptions = useMemo(() => {
    const tipoEmailValue = tipoMap.COMUNICADO;
    return [
      ...fixedOption,
      ...data
        .filter(item => item.tipoEmail === tipoEmailValue)
        .map(item => ({ value: item.id, label: item.nome }))
        .sort((a, b) => a.label.localeCompare(b.label))
    ];
  }, [data, fixedOption]);

  const solicitacaoOptions = useMemo(() => {
    const tipoEmailValue = tipoMap.SOLICITACAO;
    return [
      ...data
        .filter(item => item.tipoEmail === tipoEmailValue)
        .map(item => ({ value: item.id, label: item.nome }))
        .sort((a, b) => a.label.localeCompare(b.label))
    ];
  }, [data, fixedOption]);

  const relatorioOptions = useMemo(() => {
    const tipoEmailValue = tipoMap.RELATORIO;
    return [
      ...data
        .filter(item => item.tipoEmail === tipoEmailValue)
        .map(item => ({ value: item.id, label: item.nome }))
        .sort((a, b) => a.label.localeCompare(b.label))
    ];
  }, [data, fixedOption]);

  // Adicionando opções para Plano de Ação
  const planoAcaoOptions = useMemo(() => {
    const tipoEmailValue = tipoMap.PLANO_ACAO;
    return [
      ...data
        .filter(item => item.tipoEmail === tipoEmailValue)
        .map(item => ({ value: item.id, label: item.nome }))
        .sort((a, b) => a.label.localeCompare(b.label))
    ];
  }, [data, fixedOption]);

  // Adicionando opções para Encerramento da Solicitação
  const encerramentoOptions = useMemo(() => {
    const tipoEmailValue = tipoMap.ENCERRAMENTO;
    return [
      ...data
        .filter(item => item.tipoEmail === tipoEmailValue)
        .map(item => ({ value: item.id, label: item.nome }))
        .sort((a, b) => a.label.localeCompare(b.label))
    ];
  }, [data, fixedOption]);

  return {
    templatesLoading: loading,
    comunicadoOptions,
    solicitacaoOptions,
    relatorioOptions,
    planoAcaoOptions,
    encerramentoOptions,
    fetchTemplates: fetchAllData,
  };
}
